import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard, ConfigModule, RoutingConfig } from '@spartacus/core';
import { CmsPageGuard, PAGE_LAYOUT_HANDLER, PageLayoutComponent } from '@spartacus/storefront';
import { KnBrCustomerContextGuard } from 'src/shared/guards/kn-br-customer-context.guard';
import { KnBrMyQuotePageLayoutHandler } from './kn-br-my-quote-page-layout.handler';
import { KnBrMyQuoteHeaderModule } from './kn-br-quote-header/kn-br-my-quote-header.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KnBrMyQuoteHeaderModule,
    RouterModule.forChild([
      {
        data: { pageLabel: '/step2-quote-detail', cxRoute: 'step2CustomerQuoteDetails' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard, KnBrCustomerContextGuard],
        component: PageLayoutComponent,
      },
    ]),
    ConfigModule.withConfig({
      routing: {
        routes: {
          step2CustomerQuoteDetails: {
            paths: ['step2-quote-detail/:code'],
          },
        },
      },
    } as RoutingConfig),
  ],
  providers: [
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: KnBrMyQuotePageLayoutHandler,
      multi: true,
    },
  ],
})
export class KnBrMyQuoteDetailModule {}
